import React, { useEffect } from "react";
import { X } from "lucide-react";

import DossierForm from "./DossierForm.jsx";
import DossierGenerating from "./DossierGenerating.jsx";
import DossierHistory from "./DossierHistory.jsx";
import DossierViewer from "./DossierViewer.jsx";

function leadTitle(lead) {
  return lead?.full_name || lead?.fullName || lead?.leadName || lead?.company_name || lead?.companyName || "Lead";
}

export default function DossierModal({ lead, dossier }) {
  const locked = dossier.modalStep === "generating" && dossier.isGenerating;

  useEffect(() => {
    const onKey = (event) => {
      if (event.key === "Escape" && !locked) dossier.closeModal();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [dossier, locked]);

  if (!dossier.modalOpen) return null;

  const retry = (item) => {
    dossier.setActiveDossier(item);
    dossier.setModalStep("form");
  };

  const backToForm = () => dossier.setModalStep("form");

  return (
    <div className="dossier-modal-backdrop" onMouseDown={() => { if (!locked) dossier.closeModal(); }}>
      <section className="dossier-modal" role="dialog" aria-modal="true" onMouseDown={(event) => event.stopPropagation()}>
        <header className="dossier-modal-header">
          <div>
            <h1>{dossier.modalStep === "viewer" ? "Prospect Dossier" : dossier.modalStep === "generating" ? "Generating Dossier..." : "Research Prospect"}</h1>
            {dossier.modalStep === "form" && <p>{leadTitle(lead)}</p>}
          </div>
          {!locked && (
            <button className="Modal-Close-Btn" onClick={dossier.closeModal} title="Close">
              <X size={18} />
            </button>
          )}
        </header>

        <div className={`dossier-modal-body step-${dossier.modalStep}`}>
          {dossier.modalStep === "form" && (
            <>
              <DossierForm
                lead={lead}
                initialDossier={dossier.activeDossier}
                busy={dossier.isGenerating}
                apiError={dossier.generationError}
                onSubmit={dossier.startGeneration}
              />
              <DossierHistory
                dossiers={dossier.dossiers}
                loading={dossier.loadingHistory}
                onView={dossier.viewDossier}
                onDownload={dossier.downloadDossier}
                onRetry={retry}
              />
            </>
          )}

          {dossier.modalStep === "generating" && (
            <DossierGenerating
              dossier={dossier.activeDossier}
              status={dossier.generatingStatus}
              error={dossier.generationError}
              onBackToForm={backToForm}
              onTryAgain={backToForm}
            />
          )}

          {dossier.modalStep === "viewer" && (
            <DossierViewer
              dossier={dossier.activeDossier}
              onDownload={dossier.downloadDossier}
              onClose={dossier.closeModal}
            />
          )}
        </div>
      </section>
    </div>
  );
}
